<!--修改品目-->
<template>
  <a-modal width="50vw"
           centered
           :footer="null"
           :visible="editVisible"
           :maskClosable="false"
           :keyboard="false"
           :destroyOnClose="true"
           @cancel="cancel">
    <template slot="title">
      修改品目申请
    </template>
    <div v-if="!readOnly">
      <div style="color:red;font-weight:bold;font-size:16px;">修改品目需代理机构审核同意，审核结果会通过短信通知您。</div>
      <a-form-model class="exi_form item_100"
                    ref="editPurchaseItemForm"
                    :rules="rules"
                    :model="editPurchaseItemApplyFor"
                    :label-col="{ flex: '0 0 auto' }"
                    :wrapper-col="{ span: 24 }">
        <a-form-model-item label="原评审品目"
                           prop="beforeEditPurchaseItem">
          <b>{{editPurchaseItemApplyFor.beforeEditPurchaseItem}}</b>
        </a-form-model-item>
        <a-form-model-item label="重新选择评审品目"
                           prop="afterEditPurchaseItem">
          <a-input placeholder="请选择评审品目"
                   readOnly
                   v-model="editPurchaseItemApplyFor.afterEditPurchaseItem"
                   @click="openPurchaseItems"></a-input>
          <span slot="extra"
                style="color:red">最多允许选择{{ expert_item_max_num }}个品目</span>
        </a-form-model-item>

        <a-form-model-item label="修改原因"
                           prop="editReason">
          <a-textarea v-model.trim="editPurchaseItemApplyFor.editReason"
                      placeholder="请输入修改原因"
                      :auto-size="{ minRows: 3 }" />
        </a-form-model-item>

      </a-form-model>
      <div class="bottom-btn">
        <a-space>
          <a-button size="large"
                    :loading="confirmLoading"
                    @click="cancel">取消
          </a-button>
          <a-button type="primary"
                    size="large"
                    :loading="confirmLoading"
                    @click="submit">提交
          </a-button>
        </a-space>
      </div>
    </div>
    <div v-else>
      <table class="fx-form-view">
        <tr>
          <th>原评审品</th>
          <td><b>{{ editPurchaseItemApplyFor.beforeEditPurchaseItem}}</b></td>
        </tr>
        <tr>
          <th>修改后评审品目</th>
          <td><b>{{ editPurchaseItemApplyFor.afterEditPurchaseItem}}</b></td>
        </tr>
        <tr>
          <th>修改原因</th>
          <td><b>{{ editPurchaseItemApplyFor.editReason }}</b></td>
        </tr>
        <tr>
          <th>审核意见</th>
          <td v-if="editPurchaseItemApplyFor.auditStatus === expertAuditResultEnum.AUDIT_RESULT_FAIL">
            <b style="color: red">{{ editPurchaseItemApplyFor.auditOpinion }}</b>
          </td>
          <td v-if="editPurchaseItemApplyFor.auditStatus === expertAuditResultEnum.AUDIT_RESULT_PASS"><a-tag color="green">通过</a-tag></td>
        </tr>
      </table>
    </div>
    <div class="bottom-btn"
         v-if="editPurchaseItemApplyFor.auditStatus === expertAuditResultEnum.AUDIT_ING">
      <a-button type="danger"
                @click="onRevocation()">撤回</a-button>
    </div>
    <choose-expert-purchase-item ref="items"
                                 :visible="purchaseVisible"
                                 @success="purchaseSuccess"
                                 @cancel="purchaseVisible = false" />
  </a-modal>
</template>

<script>
import ChooseExpertPurchaseItem from '@/epp/expertmain/purchaseitems/ChooseExpertPurchaseItem.vue'
import {
  AddOrUpdateEditPurchaseItemApplyFor,
  RevocationEditPurchaseItemApplyFor,
  GetEditPurchaseItemApplyForById,
  GetEditPurchaseItemList
} from '@/epp/expertmain/expertInfo/api/ExpertInfoApi'
import { GetPurchaseItemLimitNumAndConsultTelePhone } from '@/epp/sysContentMange/api/sysContentMangeApi'
import expertAuditResultEnum from '@/utils/expertAuditResultEnum'
const uuidv4 = require('uuid/v4')

export default {
  name: "EditExpertPurchaseItem",
  components: {
    ChooseExpertPurchaseItem
  },
  data () {
    return {
      expertAuditResultEnum: expertAuditResultEnum,
      editVisible: false,
      purchaseVisible: false,
      confirmLoading: false,
      readOnly: false,
      expert_item_max_num: 0,
      rules: {
        afterEditPurchaseItem: [{ required: true, message: '请选择评审品目', trigger: 'change' }],
        editReason: [{ required: true, message: '请输入修改原因', trigger: 'blur' }],
      },
      expertInfo: {},
      editPurchaseItemApplyFor: {
        id: uuidv4(),
        expertId: "",
        beforeEditPurchaseItem: "",
        beforeEditPurchaseItemId: "",
        beforeEditPurchaseItemCode: "",
        afterEditPurchaseItem: "",
        afterEditPurchaseItemCode: "",
        afterEditPurchaseItemId: "",
        editReason: "",
      }
    }
  },
  created () {
    this.initDefaultData()
  },
  methods: {
    // 初始化默认数据
    async initDefaultData () {
      try {
        let res = await GetPurchaseItemLimitNumAndConsultTelePhone()
        if (res.code === 200 && res.result) {
          let expertItemMaxNum = res.result.expert_item_max_num
          if (expertItemMaxNum) {
            this.expert_item_max_num = parseInt(expertItemMaxNum)
          }
          /*  let phone = res.result.consult_telePhone
           this.consult_telePhone = phone */
        }
      } catch (e) {
        this.$message.error(e.message)
      } finally {

      }
    },
    async initData (expertInfo) {
      this.expertInfo = expertInfo
      const res = await GetEditPurchaseItemList(expertInfo.id, expertAuditResultEnum.AUDIT_ING)
      if (res.code === 200 && res.result.length > 0) {
        const result = res.result[0]
        if (result) {
          this.editPurchaseItemApplyFor = result
          this.readOnly = true
          this.editVisible = true
          return
        }
      }
      this.editPurchaseItemApplyFor = {
        id: uuidv4(),
        expertId: expertInfo.id,
        beforeEditPurchaseItem: expertInfo.purchaseItem,
        beforeEditPurchaseItemId: expertInfo.purchaseItemId,
        beforeEditPurchaseItemCode: expertInfo.purchaseItemCode,
        afterEditPurchaseItem: "",
        afterEditPurchaseItemCode: "",
        afterEditPurchaseItemId: "",
        editReason: "",
      }
      this.editVisible = true
    },
    async viewData (purchaseItemApplyForId, readOnly) {
      this.readOnly = readOnly
      const res = await GetEditPurchaseItemApplyForById(purchaseItemApplyForId)
      if (res.code == 200) {
        this.editPurchaseItemApplyFor = res.result
        this.editVisible = true
      }
    },
    //采购品目选择成功后
    purchaseSuccess (data) {
      this.purchaseVisible = false
      this.editPurchaseItemApplyFor.afterEditPurchaseItem = []
      this.editPurchaseItemApplyFor.afterEditPurchaseItemId = data.map(item => item.fid).join('；')
      this.editPurchaseItemApplyFor.afterEditPurchaseItem = data.map(item => item.fspmmc).join('；')
      this.editPurchaseItemApplyFor.afterEditPurchaseItemCode = data.map(item => item.fspmbm).join('；')
      this.$refs.editPurchaseItemForm.validateField('afterEditPurchaseItem')
    },
    //打开采购品目
    openPurchaseItems () {
      this.purchaseVisible = true
      let result = []
      const editPurchaseItemApplyFor = this.editPurchaseItemApplyFor
      if (editPurchaseItemApplyFor.afterEditPurchaseItem) {
        let fidArr = editPurchaseItemApplyFor.afterEditPurchaseItemId.split('；')
        let itemArr = editPurchaseItemApplyFor.afterEditPurchaseItem.split('；')
        let codeArr = editPurchaseItemApplyFor.afterEditPurchaseItemCode.split('；')
        for (let i = 0; i < fidArr.length; i++) {
          const data = {}
          data['fid'] = fidArr[i]
          data['fspmmc'] = itemArr[i]
          data['fspmbm'] = codeArr[i]
          result.push(data)
        }
      }
      this.$refs.items.preView(result)
    },
    submit () {
      const that = this
      this.$refs.editPurchaseItemForm.validate(async (valid) => {
        if (!valid) {
          return
        }
        this.$confirm({
          title: '确定提交申请修改评审品目吗?',
          onOk () {
            that.handleSubmit()
          },
        })
      })
    },
    async handleSubmit () {
      this.confirmLoading = true
      const res = await AddOrUpdateEditPurchaseItemApplyFor(this.editPurchaseItemApplyFor)
      if (res.code == 200) {
        this.$message.success('提交成功，请等待审核')
        this.editVisible = false
        this.$emit('success')
      }
      this.confirmLoading = false
    },
    /**
     * 撤回
     */
    async onRevocation () {
      const res = await RevocationEditPurchaseItemApplyFor(this.editPurchaseItemApplyFor.id)
      if (res.code == 200) {
        this.$message.success('撤回成功')
        this.readOnly = false
        this.editPurchaseItemApplyFor.auditStatus = ""
        this.$emit('revocation')
      }
    },
    cancel () {
      this.confirmLoading = false
      this.editVisible = false
    }
  },
}
</script>

<style lang="less" scoped>
.bottom-btn {
  width: 100%;
  margin-top: 25px;
  display: flex;
  justify-content: center;
}
.descriptions {
  font-size: 16px;
  margin-bottom: 20px;
  .box {
    padding: 12px 20px;
    background: #f3f3f3;
    border-radius: 8px;
    margin-bottom: 10px;
  }

  .title {
    color: #62687e;
    margin-bottom: 8px;
  }

  span {
    color: #62687e;
  }

  b {
    color: #141414;
  }
}
</style>
